import AxiosInterceptor from 'api/interceptor';

const tag = new AxiosInterceptor();

export default {
  get() {
    return tag.get('/tag');
  },
  delete(id) {
    return tag.delete('/tag/' + id);
  },
  create(inputs) {
    return tag.post('/tag', {
      'name': inputs.name
    });
  }
};